import $ from 'jquery';

const $sliders = $( '.brands__wrapper--slick' );

let $args = {
	infinite: true,
	dots: false,
	slidesToShow: 14,
	slidesToScroll: 6,
	arrows: false,
	autoplay: true,
	centerMode: true,
	pauseOnHover: true,
	cssEase: 'ease-in-out',
	useTransform: true,
	speed: 1500,
	autoplaySpeed: 0,
	responsive: [
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 2,
			}
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 3,
			}
		},
		{
			breakpoint: 1800,
			settings: {
				slidesToShow: 8,
				slidesToScroll: 4,
				speed: 2250,
			}
		},
	],
}

$sliders.slick( $args );

$sliders.on('afterChange', function(event, slick) {
	$('.slick-slide').each(function() {
		const isHidden = $(this).attr('aria-hidden') === 'true';
		$(this)
			.find('a, button, input, select, textarea, div, img')
			.attr('tabindex', isHidden ? '-1' : '0')
			.attr('aria-hidden', isHidden);
	});
});